import React from 'react';
import { Card } from 'semantic-ui-react';
import { MenuCategoryPropType } from '../../../../../../services/proptypes';
import { MenuConsumer } from '../../../../FoodMenu.context';
import MenuUtil from '../../../../utils/menu';
import ItemContainer from '../../item/ItemContainer';
import CategoryHeader from '../components/CategoryHeader/CategoryHeader';
var defaultProps = {
  scheduleCategories: []
};
var CategoryVerticalCardRows = function CategoryVerticalCardRows(_ref) {
  var category = _ref.category,
    scheduleCategories = _ref.scheduleCategories;
  return /*#__PURE__*/React.createElement(MenuConsumer, null, function (_ref2) {
    var items = _ref2.items;
    var itemIds = category.items,
      name = category.name;
    var categoryItems = MenuUtil.getCategoryItems(itemIds, items);
    return /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: '2.5rem'
      },
      id: name,
      className: "category-container"
    }, /*#__PURE__*/React.createElement(CategoryHeader, {
      category: category,
      scheduleCategories: scheduleCategories
    }), /*#__PURE__*/React.createElement("div", {
      className: "category-container-content",
      style: {
        padding: '0.75rem 2.5% 0 2.5%'
      }
    }, /*#__PURE__*/React.createElement(Card.Group, null, categoryItems.map(function (_ref3) {
      var _id = _ref3._id;
      return /*#__PURE__*/React.createElement(ItemContainer, {
        itemId: _id,
        key: _id
      });
    }))));
  });
};
CategoryVerticalCardRows.defaultProps = defaultProps;
export default CategoryVerticalCardRows;